import _ from 'lodash';
import Vue, { VNode } from 'vue';
import {mapActions, mapState} from 'vuex';
import {AlertNotificationConstant, AlertNotificationModuleConstant} from '../../constants';
import LtFramework from '../../../../types/lt/ltFramework';

interface IComponentData {
	alert: LtFramework.IAlertNotification;
}

export default Vue.component('ecError', {
	props: {
		errorMessage: String,
		errorMessageId: String,
	},
	render() {
		return {} as VNode;
	},
	data(): IComponentData {
		return {
			alert: {
				id: this.errorMessageId + 'ErrorMessage',
				type: AlertNotificationConstant.alertNotificationDanger,
				message: this.errorMessage,
				dismissible: true,
				icon: true,
				title: '',
			},
		};
	},
	computed: {
		...mapState(AlertNotificationModuleConstant.name, [AlertNotificationModuleConstant.state.alertNotifications]),
	},
	methods: {
		showErrorMessage(): Promise<void> {
			const notifications = _.filter(this.alertNotifications, ['defer', false]);

			if (notifications.length === 0 && this.errorMessage && this.errorMessage.length > 0) {
				this.alert.message = this.errorMessage;
				return this.open(this.alert);
			} else {
				return Promise.resolve();
			}
		},
		...mapActions(AlertNotificationModuleConstant.name, [
			AlertNotificationModuleConstant.action.open,
			AlertNotificationModuleConstant.action.close,
		]),
	},
	watch: {
		errorMessage(message: string) {
			if (message) {
				this.showErrorMessage();
			} else {
				this.close(this.alert);
			}
		},
	},
});
